module.exports = __webpack_public_path__ + "img/Dr. Mildred Tate talking with female students, 1955.67053895.jpg";